import { setAutoReleaseNotes } from "@payping/redux/actions";
import { Checkbox, Grid, Popover, Typography } from "@payping/web-components";
import { FC, useEffect, useState } from "react";
import { Trans } from "@payping/utils/localeUtils";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { CustomLink } from "@/components/CustomLink";
import styles from "@/assets/scss/Version.module.scss";
import { changeLog } from "./versionData";

export const Version: FC = () => {
  const { autoDisplay } = useAppSelector((state) => state.settings);
  const [visibleChangeLog, setVisibleChangeLog] = useState<boolean>(false);
  const hasUpdate = useAppSelector((state) => state.serviceWorker.hasUpdate);
  const [dontShow, setDontShow] = useState<boolean>(!autoDisplay);
  const dispatch = useAppDispatch();
  const { t } = useAppTranslation();

  const toggleDontShow = (newVal: boolean) => {
    dispatch(setAutoReleaseNotes(!newVal));
    setDontShow(newVal);
  };

  useEffect(() => {
    if (autoDisplay && window.screen.width > 900 && hasUpdate) {
      setVisibleChangeLog(true);
      const timer = setTimeout(() => {
        setVisibleChangeLog(false);
      }, 3000);

      return () => {
        clearTimeout(timer);
      };
    }
    return undefined;
  }, [autoDisplay, hasUpdate]);

  const versionElement = (
    <div className={styles.versionText}>
      <span>{process.env.REACT_APP_VERSION}</span>
    </div>
  );

  const change = changeLog.map(({ links, version }, index) => {
    const translationVersion = version.replace(/\./g, "-");
    return (
      <div key={index}>
        <Typography.Title level={4}>{version}</Typography.Title>
        <Typography.Title level={5}>{t(`releaseNotes.${translationVersion}.date`)}</Typography.Title>
        <ul>
          {t(`releaseNotes.${translationVersion}.features`, { returnObjects: true }).map((_: string, i: number) => (
            <li key={i}>
              <Trans
                i18nKey={`Wrapper:releaseNotes.${translationVersion}.features.${i}`}
                components={[
                  <span className="font-rem-15" key={"emoji"} />,
                  ...(links[i] || []).map((link: string, j: number) => <CustomLink key={j} to={link} />),
                ]}
              />
            </li>
          ))}
        </ul>
      </div>
    );
  });

  const { useBreakpoint } = Grid;
  const notDesktop = !useBreakpoint().lg;

  return !notDesktop ? (
    <Popover
      open={visibleChangeLog}
      onVisibleChange={setVisibleChangeLog}
      overlayClassName={styles.versionPopover}
      content={
        <>
          <div className={styles.releaseWrapper}>
            <div className={styles.releaseNotes}>
              <div className={styles.notesList}>{change}</div>
            </div>
            <div className={styles.gradient} />
          </div>
          <Checkbox
            className={styles.bottomCheckbox}
            checked={dontShow}
            onChange={(event: any) => toggleDontShow(event.target.checked)}
          >
            {t("autoReleaseNote")}
          </Checkbox>
        </>
      }
    >
      {versionElement}
    </Popover>
  ) : (
    versionElement
  );
};

export default Version;
